/**
 * Created by 叶子 on 2017/7/30.
 */
import * as type from './type';
import * as http from '../axios/index';

const requestData = category => ({
    type: type.REQUEST_DATA,
    category
});
export const receiveData = (data, category) => ({
    type: type.RECEIVE_DATA,
    data,
    category
});
export const countData = (countall,list,orderNo) => ({
    type: type.COUNT_All,
    countall,
    list,
    orderNo
});
export const countDataMy = (countall,list,orderNo) => ({
    type: type.COUNT_All_MY,
    countall,
    list,
    orderNo
});
export const orderNoData = (orderNo,flag) => ({
    type: type.ORDER_NO,
    orderNo,
    flag
});
export const VisibleData = (conversationVisible,orderNows) => ({
    type: type.VISIBLE_DATA,
    conversationVisible,
    orderNows
});
export const countNumData = (countNumber) => ({
    type: type.COUNT_NUMBER,
    countNumber
});

export const countNumDataMy = (countNumberMy) => ({
    type: type.COUNT_NUMBER_MY,
    countNumberMy
});

export const flagData = (flag) => ({
    type: type.FLAG,
    flag
});

/**
 * 请求数据调用方法
 * @param funcName      请求接口的函数名
 * @param params        请求接口的参数
 */
export const fetchData = ({funcName, params, stateName}) => dispatch => {
    !stateName && (stateName = funcName);
    dispatch(requestData(stateName));
    return http[funcName](params).then(res => dispatch(receiveData(res, stateName)));
};


// WEBPACK FOOTER //
// ./src/action/index.js